module.exports = __webpack_public_path__ + "img/Sales Target 1.ca58f763.png";